// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@conklin/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import IconSearch from "@conklin/XDL/Icons/IconSearch";
import { color, createLinkIconStyles, hideElementOnPrint, xScreen } from "@conklin/XDL/Utilities";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import X from "@insite/mobius/Icons/X";
import { PaginationStyle } from "@insite/mobius/Pagination";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        ${xScreen("lte", "md")} {
            gap: 20px;
        }
        ${xScreen("lte", "md")} {
            gap: 16px;
        }
        margin-bottom: 4px;
        ${hideElementOnPrint}
    `,
};

myListsDetailsOptionsStyles.topSectionWrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
        row-gap: 12px;
        width: 100%;
        background-color: ${color("common.ui2")};
        justify-content: space-between;
        padding: 8px;
        ${xScreen("lte", "md")} {
            column-gap: 16px;
            flex-direction: column;
        }
        ${PaginationStyle} {
            margin: 0;
            padding: 0;
        }
    `,
};

myListsDetailsOptionsStyles.leftSectionWrapper = {
    css: css`
        display: flex;
        width: 100%;
        column-gap: 32px;
        row-gap: 12px;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
            row-gap: 16px;
        }
    `,
};

myListsDetailsOptionsStyles.addDeleteWrapper = {
    css: css`
        display: flex;
        column-gap: 32px;
        row-gap: 12px;
    `,
};

myListsDetailsOptionsStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        column-gap: 22px;
        row-gap: 12px;
        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            column-gap: 16px;
            flex-direction: column;
        }
    `,
};

myListsDetailsOptionsStyles.search = {
    sizeVariant: "small",
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            width: 310px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    iconProps: {
        src: IconSearch,
        color: "common.ui5",
        size: 14,
        mergeCss: true,
        css: css`
            &&& {
                right: 2px;
                top: 8px;
                padding: 0;
                width: 22px;
            }
        `,
    },
};

myListsDetailsOptionsStyles.sortBySelect = {
    mergeCss: true,
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            width: 154px;
            ${xScreen("lte", "md")} {
                width: calc(100% - 52px);
            }
            ${xScreen("lte", "sm")} {
                width: calc(100% - 62px);
            }
        `,
    },
    labelProps: {
        css: css`
            &&&& {
                ${xScreen("lte", "sm")} {
                    width: 62px;
                    text-align: left;
                }
            }
        `,
    },
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
    `,
};

myListsDetailsOptionsStyles.addSelectedToCartLink = {
    ...createLinkIconStyles(ShoppingCart, "small", "left", false, {
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
        css: css`
            display: flex;
            justify-content: center;
            &:disabled {
                opacity: 0.33;
            }
        `,
    }),
};
myListsDetailsOptionsStyles.deleteSelectedLink = {
    ...createLinkIconStyles(X, "small", "left", false, {
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
        css: css`
            display: flex;
            justify-content: center;
            &:disabled {
                opacity: 0.33;
            }
        `,
    }),
};
myListsDetailsOptionsStyles.editSortOrderLink = {
    ...createLinkIconStyles(ChevronsUpDown, "small", "left", false, {
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
        css: css`
            display: flex;
            justify-content: center;
        `,
    }),
};
